export default {
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      drops: [],
    };
  },
  computed: {
    isFinalized() {
      const count = this.drops.reduce(
        (counter, { dropped }) => (dropped === true ? (counter += 1) : counter),
        0,
      );
      return this.drops.length === count;
    },
  },
  methods: {
    onDropOpen(drop) {
      this.$emit('onDropOpen', { drop, isFinalized: this.isFinalized });
    },
    onDropCorrect(drop) {
      this.setDrops(drop);
      this.$emit('onDropCorrect', { drop, isFinalized: this.isFinalized });

      if (this.isFinalized) {
        this.correctAnswersInputFirstTry(this.drops);
        this.stopTracking();
      }
    },
    onDropIncorrect() {
      this.$emit('onDropIncorrect');
    },
    setDrops(drop) {
      this.drops = this.drops.map((d) =>
        d.id === drop.id ? Object.assign({}, d, drop) : d,
      );
    },
  },
  watch: {
    items: {
      immediate: true,
      handler: function (drops) {
        this.drops = drops;
      },
    },
  },
  destroyed() {
    this.drops = [];
  },
};
